// extracted by mini-css-extract-plugin
export default {"Edit":"Edit_Edit__PRQWq","Top":"Edit_Top__hMNkT","Logo":"Edit_Logo__3hnfb","File":"Edit_File__l66po"};